"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseSchema = void 0;
const zod_1 = require("zod");
const _1 = require(".");
exports.BaseSchema = zod_1.z.object({
    id: _1.ShortStringSchema,
    createdAt: zod_1.z.coerce.date(),
    updatedAt: zod_1.z.coerce.date(),
});
//# sourceMappingURL=base.js.map